// extracted by mini-css-extract-plugin
module.exports = {"panelItem":"Item_panelItem__1ohRb","panelItemImage":"Item_panelItemImage__NxxYf","panelItemMod":"Item_panelItemMod__2RLTK"};